import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-sage-50" data-id="element-122" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-123" data-mp="223el1k29z72x">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-sage-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-forest/5" data-id="element-124" data-mp="222d7n8xse8i1">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-leaf" data-id="element-125" data-mp="1j52bvybd5x7c" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold-light border-2 border-gold text-forest mb-8" data-id="element-126" data-mp="1ee3tmt6tep1g">
            <ShieldCheck size={48} data-id="element-127" data-mp="qmycmap51qpk" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-forest uppercase" data-id="element-128" data-mp="lp6f915q5cdz">
            7-Day Guarantee
          </h2>
          <div className="space-y-6 text-lg text-charcoal max-w-2xl mx-auto" data-id="element-129" data-mp="oyqck576zphk">
            <p data-id="element-130" data-mp="txt91193wndx">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-forest" data-id="element-131" data-mp="ypb79hjqw9v7">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and the case will be reviewed according to the guarantee terms.
            </p>
            <p className="text-sm text-charcoal/60 mt-8" data-id="element-132" data-mp="b0jn9dgb6xti">The product is delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}